import React from 'react';
import './DoubleTeaserContainer.scss';

const DoubleTeaserContainer = ({ children }) => (
  <div className="c-double-teaser-container">{children}</div>
);

export default DoubleTeaserContainer;
